import React from 'react';

interface Feature {
  icon: string;
  title: string;
  description: string;
}

const features: Feature[] = [
  {
    icon: '🔒',
    title: 'Secure Transactions',
    description: 'Bank-level encryption and security protocols to protect your payments.',
  },
  {
    icon: '⚡',
    title: 'Lightning Fast',
    description: 'Process payments instantly with our high-speed infrastructure.',
  },
  {
    icon: '🌍',
    title: 'Global Reach',
    description: 'Accept payments from customers worldwide in multiple currencies.',
  },
  {
    icon: '📊',
    title: 'Analytics Dashboard',
    description: 'Track and analyze your payment data with comprehensive insights.',
  },
  {
    icon: '💳',
    title: 'Multiple Payment Methods',
    description: 'Support for credit cards, debit cards, digital wallets, and more.',
  },
  {
    icon: '🛡️',
    title: 'Fraud Protection',
    description: 'Advanced fraud detection and prevention systems.',
  },
];

const Features: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Why Choose GlobalPay Direct?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            We provide everything you need to accept payments securely and efficiently.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="text-5xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
